<template>
    <v-footer
     dark
     padless
    >
        <v-card
         class="flex white--text"
         flat
         tile
        >
            <v-card-title class="footer">
                v2.0.0
                <v-spacer></v-spacer>

                <span>©2023 - <strong>DEV-MatheusDiniz</strong></span>

                <v-spacer></v-spacer>

                <v-btn
                 href="https://www.linkedin.com/in/matheus-diniz-941935187/"
                 target="_blank"
                 class="mx-1"
                 dark
                 icon
                >
                    <v-icon size="24px">mdi-linkedin</v-icon>
                </v-btn>
                
                <v-btn
                 href="https://github.com/DEV-MatheusDiniz"
                 target="_blank"
                 class="mx-1"
                 dark
                 icon
                >
                    <v-icon size="24px">mdi-github</v-icon>
                </v-btn>
            </v-card-title>
        </v-card>
    </v-footer>
</template>

<script>
  export default {
    name: 'FooterComp',

    data: () => ({
      icons: [
        'mdi-linkedin',
        'mdi-github',
      ],
    }),
  }
</script>
